import React from 'react';
import { TextV2, Box, TextArea, ButtonV2, Flex } from '@withjoy/joykit';
import { useBasicNoteController } from './BasicNote.controller';
import { GetDataForThanksForRSVPQuery } from '@graphql/generated';
import { filledButtonOverrides } from './BasicNote.styles';

interface BasicNoteProps {
  setShowPreview: React.Dispatch<React.SetStateAction<boolean>>;
  message: string;
  setMessage: React.Dispatch<React.SetStateAction<string>>;
  eventHandle: string;
  queryData?: GetDataForThanksForRSVPQuery;
}

export const BasicNote: React.FC<BasicNoteProps> = ({ setShowPreview, message, setMessage, eventHandle, queryData }) => {
  const { tCongratulationsCard, isGeneratedMessageLoading, handlePreviewYourNote, handleOnBlur } = useBasicNoteController(setShowPreview, setMessage, eventHandle, queryData);

  return (
    <Box
      paddingBottom={5}
      paddingX={58}
    >
      <TextV2
        typographyVariant="label3"
        marginBottom={3}
      >
        {tCongratulationsCard.yourNoteTitle()}
      </TextV2>
      <TextArea
        minRows={5}
        placeholder={tCongratulationsCard.notePlaceholder()}
        value={message}
        onChange={e => setMessage(e.target.value)}
        onBlur={handleOnBlur}
        disabled={isGeneratedMessageLoading}
      />
      <Flex
        marginTop="24px"
        alignItems="center"
        justifyContent="center"
      >
        <ButtonV2
          size="lg"
          onClick={handlePreviewYourNote}
          loading={isGeneratedMessageLoading}
          overrides={filledButtonOverrides}
          width="100%"
          disabled={!message}
        >
          {tCongratulationsCard.previewYourNote()}
        </ButtonV2>
      </Flex>
    </Box>
  );
};
